import { isWindowDefined } from './isWindowDefined'

export const SESSION_STORAGE_KEYS = {
  searchData: 'searchData',
  ucfLoginSuccess: 'ucfLoginSuccess',
  fetchingToken: 'fetchingToken',
  queryStringQAParams: 'queryStringQAParams',
  formData: 'formData',
  formRoute: 'formRoute',
  citationObject: 'citationObject',
  upgradeCitationObject: 'upgradeCitationObject',
  selectedCitations: 'selectedCitations',
  authSuccess: 'authSuccess',
  transferOwnership: 'transferOwnership',
  role: 'role',
}

export const setSessionStorageItem = (key: string, value: string) => {
  if (
    isWindowDefined &&
    window.sessionStorage &&
    typeof window.sessionStorage.setItem === 'function'
  ) {
    try {
      window.sessionStorage.setItem(key, value)
    } catch (e) {
      return undefined
    }
  }
}

export const getSessionStorageItem = (key: string): string | null => {
  if (
    isWindowDefined &&
    window.sessionStorage &&
    typeof window.sessionStorage.getItem === 'function'
  ) {
    try {
      return window.sessionStorage.getItem(key)
    } catch (e) {
      return null
    }
  }
  return null
}

export const removeSessionStorageItem = (key: string) => {
  if (
    isWindowDefined &&
    window.sessionStorage &&
    typeof window.sessionStorage.removeItem === 'function'
  ) {
    try {
      window.sessionStorage.removeItem(key)
    } catch (e) {
      // Silently fail if sessionStorage is not accessible
    }
  }
}
